import { render, staticRenderFns } from "./newOrder.vue?vue&type=template&id=835a048e&scoped=true&"
import script from "./newOrder.vue?vue&type=script&lang=ts&"
export * from "./newOrder.vue?vue&type=script&lang=ts&"
import style0 from "./newOrder.vue?vue&type=style&index=0&id=835a048e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835a048e",
  null
  
)

export default component.exports